module.exports = __webpack_public_path__ + "static/media/motor.89674e49.png";